var colors = {
  blackDeep: '#000',
  black: '#222',
  white: '#fff',
  transparent: 'transparent',
  gray_500: '#c4c4c4',
  gray_100: '#fdfdfd',
  gray_200: '#f5f5f5',
  gray_300: '#e0e0e0',
  gray_400: '#d2d2d2',
  gray_600: '#9f9f9f',
  gray_700: '#787878',
  gray_800: '#4d4d4d',
  gray_900: '#222222',
  coolGray_100: '#f9fbfc' /** sticky-table table $cool-gray(box button-group dropdown form-field form-title menu-btn nested-tile sticky-table table tile ) (XDS - gray 1) **/,
  coolGray_200: '#f3f6f9' /** none (XDS - gray 2) **/,
  coolGray_300: '#e3e9ed' /** none (XDS - gray 3) **/,
  coolGray_400: '#ced7e0' /** none (XDS - gray 4) **/,
  coolGray_500: '#b9c6d3' /** none (XDS - gray 5) **/,
  coolGray_600: '#94a1b0' /** none (XDS - gray 6) **/,
  coolGray_700: '#6b7789' /** none (XDS - gray 7) **/,
  coolGray_800: '#4e5969',
  coolGray_900: '#2f3847',
  red_500: '#cf102d',
  red_100: '#fae7ea',
  red_200: '#fcc0c0',
  red_300: '#f98686',
  red_400: '#f54747',
  red_600: '#a60e25',
  red_700: '#7c0a1c',
  red_800: '#530712',
  red_900: '#290309',
  coral_500: '#ed7766',
  coral_100: '#fce4e1',
  coral_200: '#fcc2b6',
  coral_300: '#fc9983',
  coral_400: '#f48874',
  coral_600: '#e5624f',
  coral_700: '#d44025',
  coral_800: '#873226',
  coral_900: '#2f1814',
  yellow_500: '#ffbb00',
  yellow_100: '#fff8e5',
  yellow_200: '#ffe48d',
  yellow_300: '#ffd64c',
  yellow_400: '#ffc900',
  yellow_600: '#cc9600',
  yellow_700: '#9f6f00',
  yellow_800: '#6a4b00',
  yellow_900: '#352500',
  green_500: '#00c39c',
  green_100: '#ccf3ec',
  green_200: '#78eac4',
  green_300: '#18e09a',
  green_400: '#0cd29a',
  green_600: '#02a081',
  green_700: '#03725e',
  green_800: '#025243',
  green_900: '#00271f',
  lightBlue_500: '#45bce5',
  lightBlue_100: '#d9eeff',
  lightBlue_200: '#d0eef8',
  lightBlue_300: '#a2ddf2',
  lightBlue_400: '#74cdec',
  lightBlue_600: '#3796b7',
  lightBlue_700: '#297189',
  lightBlue_800: '#1c4b5c',
  lightBlue_900: '#0e262e',
  blue_500: '#0033a0',
  blue_100: '#d9e1f1',
  blue_200: '#bfcce7',
  blue_300: '#7f99cf',
  blue_400: '#4066b8',
  blue_600: '#002e90',
  blue_700: '#002980',
  blue_800: '#00246f',
  blue_900: '#001e60',
  navy_500: '#0e1941',
  navy_100: '#dcdde3',
  navy_200: '#c3c7d8',
  navy_300: '#757b95',
  navy_400: '#273054',
  navy_600: '#0d173b',
  navy_700: '#0b1434',
  navy_800: '#0a112d',
  navy_900: '#040610',
  purple_500: '#bd70f4',
  purple_100: '#f1ccff',
  purple_200: '#e3b2ff',
  purple_300: '#d699ff',
  purple_400: '#c984f9',
  purple_600: '#a750ea',
  purple_700: '#9232E2',
  purple_800: '#500974',
  purple_900: '#250033'
};
export default colors;